import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { LogActivityService } from '../../../../services/settings-services/log-activity.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from 'src/app/services/general.service';
import { noWhitespaceValidator } from 'src/app/utils/no-whitespace.validator';
import { EmailService } from 'src/app/services/integrations/email/email.service';
import { selectConfig } from 'src/app/utils/utils';
import { Observable, Subject, forkJoin } from 'rxjs';
import $ from "jquery";
import { takeUntil } from 'rxjs/operators';
import { DealsService } from 'src/app/services/deals.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { EmailClientService } from 'src/app/services/integrations/email/email-client.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-log-activity',
  templateUrl: './log-activity.component.html',
  styleUrls: ['./log-activity.component.css']
})
export class LogActivityComponent implements OnInit, OnDestroy {

  private unsubscribe = new Subject<any>();
  user;
  @Input() showLog = false
  @Input() modalId = "log-modal";
  today: Date = new Date();
  pageContext;
  showLoading: boolean = false;
  pageNo: any = 0;
  activityLogs: any = [];
  clientList;
  dealList$: Observable<any>;

  Clientconfig = { ...selectConfig, placeholder: 'Search Client', noResultsFound: "Type here to search" };
  Dealconfig = { ...selectConfig, placeholder: 'Search Deal', noResultsFound: "Client Has No Deal" };

  addLogActivityForm = new FormGroup({
    type: new FormControl('', [Validators.required]),
    content: new FormControl('', [Validators.required, noWhitespaceValidator]),
    date: new FormControl('', [Validators.required]),
    time: new FormControl('', [Validators.required]),
    duration: new FormControl('', [Validators.required]),
    clientID: new FormControl(''),
    dealCode: new FormControl(''),
    teamID: new FormControl(''),
    clientName: new FormControl(''),
    dealName: new FormControl(''),
    teamName: new FormControl(''),
    otherID: new FormControl(''),
    otherName: new FormControl(''),
    userID: new FormControl(''),
  });

  addLogActivityModalForm = new FormGroup({
    type: new FormControl('', [Validators.required]),
    content: new FormControl('', [Validators.required, noWhitespaceValidator]),
    date: new FormControl('', [Validators.required]),
    time: new FormControl('', [Validators.required]),
    duration: new FormControl('', [Validators.required]),
    client: new FormControl('', [Validators.required]),
    deal: new FormControl(''),
    team: new FormControl(''),
    clientName: new FormControl(''),
    dealName: new FormControl(''),
    teamName: new FormControl(''),
    otherID: new FormControl(''),
    otherName: new FormControl(''),
    userID: new FormControl(''),
  });

  constructor(
    private logActSrv: LogActivityService,
    private router: Router,
    private generalSrv: GeneralService,
    private emailClientService: EmailClientService,
    private emailService: EmailService,
    private dealServ: DealsService,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe(info => {
      this.user = info.user.id;
    });
  }

  ngOnInit() {
    this.getPageContext();
    this.fetchLogActivityTypes();

    //refresh Types
    this.logActSrv.refreshNeeded$
      .subscribe(() => {
        this.fetchLogActivityTypes();
      })
  }

  /**
   * Fetch Activity Type
   */
  private fetchLogActivityTypes() {
    this.logActSrv.getActivityTypes().pipe(takeUntil(this.unsubscribe)).subscribe(activityLogs => {
      this.activityLogs = activityLogs;
    })
  }

  /**
  * Add New Activity Log
  */
  onAddNewActivityLog() {
    this.addNewActivityLog();
  }

  /**
   * Reset Page Form
   */
  resetForm() {
    this.addLogActivityForm.controls.type.reset();
    this.addLogActivityForm.controls.content.reset();
    this.addLogActivityForm.controls.date.reset();
    this.addLogActivityForm.controls.time.reset();
    this.addLogActivityForm.controls.duration.reset();
  }

  /**
   * Add New Activity Log
   */
  addNewActivityLog() {
    if (this.addLogActivityForm.value.duration < 0) {
      this.generalSrv.sweetAlertError('Negative Duration Is Not Allowed')
    } else {
      this.showLoading = true;
      this.logActSrv.createNewActivityLog(this.addLogActivityForm.getRawValue()).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.showLoading = false;
        this.generalSrv.sweetAlertCreateSuccessWithoutNav('Activity Log');
        this.logActSrv.refreshNeeded$
        .subscribe(() => {
          this.getPageContext();
        })
        this.resetForm();
      }, (error) => {
        this.showLoading = false;
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      })
    }
  }

  /**
  * Add New Activity Log
  */
  addModalActivityLog() {
    this.addLogActivityForm.patchValue({
      type: this.addLogActivityModalForm.value.type,
      content: this.addLogActivityModalForm.value.content,
      date: this.addLogActivityModalForm.value.date,
      time: this.addLogActivityModalForm.value.time,
      duration: this.addLogActivityModalForm.value.duration,
      clientID: (this.addLogActivityModalForm.value.client.clientId || this.addLogActivityModalForm.value.client.id),
      dealCode: (this.addLogActivityModalForm.value.deal ? this.addLogActivityModalForm.value.deal.code : ''),
      teamID: (this.addLogActivityModalForm.value.deal ? this.addLogActivityModalForm.value.deal.teamID : ''),
      clientName: (this.addLogActivityModalForm.value.client ? this.addLogActivityModalForm.value.client.name : ''),
      dealName: (this.addLogActivityModalForm.value.deal ? this.addLogActivityModalForm.value.deal.name : ''),
      otherID: (this.addLogActivityModalForm.value.client ? this.addLogActivityModalForm.value.client.id : ''),
      otherName: (this.addLogActivityModalForm.value.client ? this.addLogActivityModalForm.value.client.type : ''),
      userID: this.user,
    });
    if (this.addLogActivityModalForm.value.duration < 0) {
      this.generalSrv.sweetAlertError('Negative Duration Is Not Allowed')
    } else {
      this.showLoading = true;
      this.logActSrv.createNewActivityLog(this.addLogActivityForm.getRawValue())
        .pipe(takeUntil(this.unsubscribe)).subscribe(() => {
          this.showLoading = false;
          this.generalSrv.sweetAlertCreateSuccessWithoutNav('Activity Log');
          this.logActSrv.refreshNeeded$
          .subscribe(() => {
            this.getPageContext();
          })
          $(`#closeModal`).click();
          this.resetForm();
          this.discard()
          this.reload()
        }, (error) => {
          this.showLoading = false;
          this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
        })
    }

  }

    reload() {
    const currentUrl = this.router.url;
    this.router
      .navigateByUrl("/refresh", { skipLocationChange: true })
      .then(() => {
        this.router.navigate([currentUrl]);
      })
      .catch((error) => {
        console.error("Error reloading page:", error);
      });
  }

  discard() {
    this.addLogActivityModalForm.reset();
    this.addLogActivityForm.reset();
    this.clientList = [];
    this.addLogActivityModalForm.controls['client'].patchValue([]);
    this.addLogActivityModalForm.controls['deal'].patchValue([]);
  }

  getPageContext() {
    this.emailService.email_context.subscribe((context: any) => {
      if (!this.generalSrv.checkIfObjectIsEmpty(context)) {
        this.pageContext = context.name;
        this.getPageData(context);
      }
    });
  }

  getPageData(context) {
    switch (context.name) {
      case 'deal':
        this.addLogActivityForm.patchValue({ userID: this.user });
        this.addLogActivityForm.patchValue({ dealName: context.deal.name });
        this.addLogActivityForm.patchValue({ dealCode: context.data.id });
        this.addLogActivityForm.patchValue({ teamID: context.deal.teamID });        
        break;

      case 'lead':
        this.addLogActivityForm.patchValue({ userID: this.user });
        this.addLogActivityForm.patchValue({ clientName: context.lead.sourceValue });
        this.addLogActivityForm.patchValue({ clientID: context.data.id });
        this.addLogActivityForm.patchValue({ otherID: context.data.id });
        this.addLogActivityForm.patchValue({ otherName: context.name });
        break;

      case 'company':
        this.addLogActivityForm.patchValue({ userID: this.user });
        this.addLogActivityForm.patchValue({ clientName: context.company.name });
        this.addLogActivityForm.patchValue({ clientID: context.company.clientId });
        this.addLogActivityForm.patchValue({ teamID: context.company.teamId });
        this.addLogActivityForm .patchValue({ otherID: context.company.id });
        this.addLogActivityForm .patchValue({ otherName: context.name });
        break;

      case 'contact':
        this.addLogActivityForm.patchValue({ userID: this.user });
        this.addLogActivityForm.patchValue({ clientName: context.contact.firstName + " " + context.contact.surName });
        this.addLogActivityForm.patchValue({ clientID: context.contact.clientId });
        this.addLogActivityForm.patchValue({ teamID: context.contact.teamId });
        this.addLogActivityForm .patchValue({ otherID: context.contact.id });
        this.addLogActivityForm .patchValue({ otherName: context.name });
        break;

      case 'salesPerson':
        this.addLogActivityForm.patchValue({ userID: context.data.id });
        break;

      case 'teams':
        this.addLogActivityForm.patchValue({ userID: this.user });
        this.addLogActivityForm.patchValue({ teamID: context.data.id });
        break;

      default:
        break;
    }
  }

  clientLookUp(value) {
    const inputText = value.trim()
    if (!inputText) {
      this.clearSuggestedUsers();
      return;
    }
    this.Clientconfig.noResultsFound = 'No results found!'
    const leads_lookup = this.emailClientService.fetchClientsByWildcard(value, "leads");
    const contacts_lookup = this.emailClientService.fetchClientsByWildcard(value, "contacts");
    const companies_lookup = this.emailClientService.fetchClientsByWildcard(value, "companies");
    forkJoin([leads_lookup, contacts_lookup, companies_lookup]).subscribe(
      (responses: any) => {
        let lookUp = [];

        if (responses[0].success) {
          lookUp = [...lookUp, ...responses[0].payload]
        }

        if (responses[1]) {
          lookUp = [...lookUp, ...responses[1].payload]
        }

        if (responses[2]) {
          lookUp = [...lookUp, ...responses[2].payload]
        }

        this.clientList = inputText.trim() ? [...lookUp] : [];
      })

  }

  clearSuggestedUsers() {
    this.clientList = [];
  }

  updateNoResultText() {
    const el = document.querySelector('.ngx-dropdown-container .ngx-dropdown-list-container ul li:last-child')
    el.textContent = 'No results found!'
  }

  getClientDeals() {
    this.addLogActivityModalForm.patchValue({ deal: '' });
    const clientInfo = this.addLogActivityModalForm.value.client;
    this.dealList$ = this.dealServ.getAllContactDeals("client", clientInfo.clientId)
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
